import React from 'react'

const test = () => {
  return (
    <div>

    this is text
      
    </div>
  )
}

export default test
